import { Directive, inject, input, TemplateRef } from '@angular/core';
import { TableFilterTemplateContext } from '../types';

@Directive({
  selector: 'ng-template[uiFilterTemplate]',
  standalone: true,
})
export class FilterTemplateDirective {
  public templateRef = inject(TemplateRef);
  controlName = input.required<string>({ alias: 'uiFilterTemplate' });

  static ngTemplateContextGuard(
    dir: FilterTemplateDirective,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ctx: unknown,
  ): ctx is TableFilterTemplateContext {
    return true;
  }
}
